import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// 引入组件
import Login from "../views/Login.vue";

// 配置
const routes = [
  // 重定向
  {
    path: "/",
    redirect: "/login",
  },
  // 登录
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/index/content/manuscripts",
    name:'10',
    component: () => import("../views/Content/Manuscripts/manuscripts.vue"),
  },
  {
    path: "/index/content/manuscripts_edit",
    name:'20,24,30',
    component: () => import("../views/Content/Manuscripts/manuscripts_edit.vue"),
  },
  // 后端首页
  {
    path: "/index",
    meta: {
      bread: { path: "/index", title: "后端首页" },
    },
    component: () => import("../views/Index.vue"), // 路由的懒加载 【按需加载】
    children: [
      {
        meta: {
          bread: { path: "/index/403", title: "无权限页" },
        },
        path: "/index/403",
        name:'403403',
        component: () => import("../views/403.vue"),
      },
      // 首页
      {
        meta: {
          bread: { path: "/index", title: "工作台" },
        },
        path: "/index/home",
        name:'01',
        component: () => import("../views/WorkBench/work_bench_two.vue"),
      },
      {
        meta: {
          bread: { path: "/index/content/all_manuscripts", title: "所有稿件" },
        },
        path: "/index/content/all_manuscripts",
        name:'08',
        component: () => import("../views/Content/AllManuscripts/all_manuscripts.vue"),
      },
      {
        meta: {
          bread: { path: "/index/content/column_manuscript", title: "栏目稿件" },
        },
        path: "/index/content/column_manuscript",
        name:'09',
        component: () => import("../views/Content/ColumnManuscript/column_manuscript.vue"),
      },
      {
        meta: {
          bread: { path: "/index/content/column_manuscript/manuscripts_edit", title: "编辑稿件" },
        },
        path: "/index/content/column_manuscript/manuscripts_edit",
        component: () => import("../views/Content/Manuscripts/manuscripts_edit.vue"),
      },
      {
        meta: {
          bread: { path: "/index/content/we_chat", title: "微信公众号" },
        },
        name:'11',
        path: "/index/content/we_chat",
        component: () => import("../views/Content/WeChat/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/content/sina_weibo", title: "新浪微博" },
        },
        name:'12',
        path: "/index/content/sina_weibo",
        component: () => import("../views/Content/SinaWeibo/index.vue"),
      },

      {
        meta: {
          bread: { path: "/index/content/manuscript_submitted", title: "稿件报送" },
        },
        name:'346',
        path: "/index/content/manuscript_submitted",
        component: () => import("../views/Content/ManuscriptSubmitted/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/content/platform_solicitation", title: "平台约稿" },
        },
        name:'382',
        path: "/index/content/platform_solicitation",
        component: () => import("../views/Content/PlatformSolicitation/index.vue"),
      },

      {
        meta: {
          bread: { path: "/index/content/manuscript_adopt", title: "稿件采纳" },
        },
        name:'361',
        path: "/index/content/manuscript_adopt",
        component: () => import("../views/Content/ManuscriptAdopt/index.vue"),
      },

      {
        meta: {
          bread: { path: "/index/content/submit_statistics", title: "报送统计" },
        },
        name:'395',
        path: "/index/content/submit_statistics",
        component: () => import("../views/Content/SubmitStatistics/index.vue"),
      },






      // 互动路由
      {
        meta: {
          bread: { path: "/index/interaction/12345_mailbox", title: "12345信箱" },
        },
        name:'46',
        path: "/index/interaction/12345_mailbox",
        component: () => import("../views/Interaction/12345Mailbox/12345_mailbox.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/secretary_mailbox", title: "书记信箱" },
        },
        name:'47',
        path: "/index/interaction/secretary_mailbox",
        component: () => import("../views/Interaction/SecretaryMailbox/secretary_mailbox.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/governor_mailbox", title: "州长信箱" },
        },
        name:'48',
        path: "/index/interaction/governor_mailbox",
        component: () => import("../views/Interaction/GovernorMailbox/governor_mailbox.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/knowledge_base", title: "问答库" },
        },
        name:'43',
        path: "/index/interaction/knowledge_base",
        component: () => import("../views/Interaction/KnowledgeBase/knowledge_base.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/knowledge_base/add", title: "新增问答" },
        },
        name:'58',
        path: "/index/interaction/knowledge_base/add",
        component: () => import("../views/Interaction/KnowledgeBase/add_answers.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/interaction/response_record", title: "问答记录" },
      //   },
      //   path: "/index/interaction/response_record",
      //   name:'', // 暂时没有
      //   component: () => import("../views/Interaction/ResponseRecord/response_record.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/interaction/unknown_problem", title: "未知问题" },
        },
        name:'44',
        path: "/index/interaction/unknown_problem",
        component: () => import("../views/Interaction/UnknownProblem/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/answers_setting", title: "智能问答设置" },
        },
        name:'45',
        path: "/index/interaction/answers_setting",
        component: () => import("../views/Interaction/AnswersSetting/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/solicitation_survey", title: "意见征集" },
        },
        name:'41',
        path: "/index/interaction/solicitation_survey",
        component: () => import("../views/Interaction/SolicitationSurvey/solicitation_survey.vue"),
      },
      {
        meta: {
          bread: { path: "/index/questionnaire", title: "问卷调查" },
        },
        name:'292',
        path: "/index/questionnaire",
        component: () => import("../views/Questionnaire/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/questionnaire/details", title: "问卷详情" },
        },
        name:'297',
        path: "/index/questionnaire/details",
        component: () => import("../views/Questionnaire/components/questionnaire_details.vue"),
      },
      {
        meta: {
          bread: { path: "/index/questionnaire/add", title: "新增问卷" },
        },
        name:'295',
        path: "/index/questionnaire/add",
        component: () => import("../views/Questionnaire/components/add_questionnaire.vue"),
      },
      {
        meta: {
          bread: { path: "/index/applicationlist", title: "申请清单" },
        },
        name:'302',
        path: "/index/applicationlist",
        component: () => import("../views/ApplicationList/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/reporting", title: "申请报备" },
        },
        name:'302',
        path: "/index/reporting",
        component: () => import("../views/Reporting/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/applicationlist/add", title: "清单申请" },
        },
        name:'41',
        path: "/index/applicationlist/add",
        component: () => import("../views/ApplicationList/components/add.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/solicitation_survey/add_solicitation", title: "新增征集" },
        },
        name:'49,51',
        path: "/index/interaction/solicitation_survey/add_solicitation",
        component: () => import("../views/Interaction/SolicitationSurvey/add_solicitation.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/online_interview", title: "在线访谈" },
        },
        name:'42',
        path: "/index/interaction/online_interview",
        component: () => import("../views/Interaction/OnlineInterview/online_interview.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/online_interview/add", title: "新增访谈" },
        },
        name:'53,56',
        path: "/index/interaction/online_interview/add",
        component: () => import("../views/Interaction/OnlineInterview/add_solicitation.vue"),
      },
      {
        meta: {
          bread: { path: "/index/interaction/online_interview/forbidden_list", title: "禁言名单" },
        },
        name:'54',
        path: "/index/interaction/online_interview/forbidden_list",
        component: () => import("../views/Interaction/OnlineInterview/forbidden_list.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/interaction/online_message", title: "在线留言" },
      //   },
      //   name:'', // 暂时没有
      //   path: "/index/interaction/online_message",
      //   component: () => import("../views/Interaction/OnlineMessage/online_message.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/configure/site_settings", title: "站点设置" },
        },
        name:'69',
        path: "/index/configure/site_settings",
        component: () => import("../views/Configure/SiteSettings/site_settings.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/column_management", title: "栏目管理" },
        },
        name:'70',
        path: "/index/configure/column_management",
        component: () => import("../views/Configure/ColumnManagement/column_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/column_management/add_column", title: "添加栏目" },
        },
        name:'81,82',
        path: "/index/configure/column_management/add_column",
        component: () => import("../views/Configure/ColumnManagement/add_column.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/template_management", title: "模板管理" },
        },
        name:'73',
        path: "/index/configure/template_management",
        component: () => import("../views/Configure/TemplateManagement/template_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/template_management/add_file", title: "新增文件" },
        },
        name:'92',
        path: "/index/configure/template_management/add_file",
        component: () => import("../views/Configure/TemplateManagement/add_file.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/custom_variables", title: "自定义变量" },
        },
        name:'74',
        path: "/index/configure/custom_variables",
        component: () => import("../views/Configure/CustomVariables/custom_variables.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/substance_model_management", title: "内容模型管理" },
        },
        name:'71',
        path: "/index/configure/substance_model_management",
        component: () => import("../views/Configure/SubstanceModelManagement/substance_model_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/substance_model_management/field_management", title: "字段管理" },
        },
        name:'85',
        path: "/index/configure/substance_model_management/field_management",
        component: () => import("../views/Configure/SubstanceModelManagement/field_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/workflow_configuration", title: "工作流配置" },
        },
        name:'75',
        path: "/index/configure/workflow_configuration",
        component: () => import("../views/Configure/WorkflowConfigurationTwo/index.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/configure/workflow_configuration/design_process", title: "流程设计" },
      //   },
      //   name:'',
      //   path: "/index/configure/workflow_configuration/design_process",
      //   component: () => import("../views/Configure/WorkflowConfiguration/design_process.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/configure/workflow_configuration/operation_records", title: "运行记录" },
        },
        name:'338',
        path: "/index/configure/workflow_configuration/operation_records",
        component: () => import("../views/Configure/WorkflowConfigurationTwo/operation_records.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/configure/message_template_management", title: "消息模板管理" },
      //   },
      //   name:'',
      //   path: "/index/configure/message_template_management",
      //   component: () => import("../views/Configure/MessageTemplateManagement/message_template_management.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/configure/weChat_official_account", title: "微信公众号" },
        },
        name:'77',
        path: "/index/configure/weChat_official_account",
        component: () => import("../views/Configure/WeChat/weChat_official_account.vue"),
      },
      {
        meta: {
          bread: { path: "/index/configure/sina_weibo", title: "新浪微博" },
        },
        name:'78',
        path: "/index/configure/sina_weibo",
        component: () => import("../views/Configure/SinaWeibo/sina_weibo.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/configure/today_headline", title: "今日头条" },
      //   },
      //   name:'79',
      //   path: "/index/configure/today_headline",
      //   component: () => import("../views/Configure/TodayHeadline/today_headline.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/configure/dithering", title: "抖音" },
        },
        name:'80',
        path: "/index/configure/dithering",
        component: () => import("../views/Configure/Dithering/dithering.vue"),
      },
      {
        meta: {
          bread: { path: "/index/userManagement/organizational_structure", title: "组织架构" },
        },
        name:'119',
        path: "/index/userManagement/organizational_structure",
        component: () => import("../views/UserManagement/OrganizationalStructure/organizational_structure.vue"),
      },
      {
        meta: {
          bread: { path: "/index/userManagement/role_management", title: "角色管理" },
        },
        name:'120',
        path: "/index/userManagement/role_management",
        component: () => import("../views/UserManagement/RoleManagement/role_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/userManagement/permission_management", title: "权限管理" },
        },
        name:'127',
        path: "/index/userManagement/permission_management",
        component: () => import("../views/UserManagement/RoleManagement/permission_management.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/userManagement/administrator_management", title: "管理员管理" },
      //   },
      //   name:'121',
      //   path: "/index/userManagement/administrator_management",
      //   component: () => import("../views/UserManagement/AdministratorManagement/administrator_management.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/userManagement/user_management", title: "用户管理" },
        },
        name:'122',
        path: "/index/userManagement/user_management",
        component: () => import("../views/UserManagement/UserManagement/user_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/statistics/website_overview", title: "网站概况" },
        },
        name:'134',
        path: "/index/statistics/website_overview",
        component: () => import("../views/Statistics/WebsiteOverview/website_overview.vue"),
      },
      {
        meta: {
          bread: { path: "/index/statistics/user_analysis", title: "用户分析" },
        },
        name:'135',
        path: "/index/statistics/user_analysis",
        component: () => import("../views/Statistics/UserAnalysis/user_analysis.vue"),
      },
      {
        meta: {
          bread: { path: "/index/statistics/site_evaluation", title: "站点指标评估" },
        },
        name:'136',
        path: "/index/statistics/site_evaluation",
        component: () => import("../views/Statistics/SiteEvaluation/site_evaluation.vue"),
      },
      {
        meta: {
          bread: { path: "/index/statistics/test_date", title: "指标监测日志" },
        },
        name:'320',
        path: "/index/statistics/test_date",
        component: () => import("../views/Statistics/TestDate/index.vue"),
      },
      {
        meta: {
          bread: { path: "/index/statistics/new_media_monitoring", title: "新媒体监测" },
        },
        name:'137',
        path: "/index/statistics/new_media_monitoring",
        component: () => import("../views/Statistics/NewMediaMonitoring/new_media_monitoring.vue"),
      },
      {
        meta: {
          bread: { path: "/index/statistics/performance_appraisal", title: "绩效考核评分" },
        },
        name:'433',
        path: "/index/statistics/performance_appraisal",
        component: () => import("../views/Statistics/PerformanceAppraisal/index.vue"),
      },
      // {
      //   meta: {
      //     bread: { path: "/index/system/system_settings", title: "系统设置" },
      //   },
      //   name:'139',
      //   path: "/index/system/system_settings",
      //   component: () => import("../views/System/SystemSettings/system_settings.vue"),
      // },
      {
        meta: {
          bread: { path: "/index/system/station_group_management", title: "站群管理" },
        },
        name:'140',
        path: "/index/system/station_group_management",
        component: () => import("../views/System/StationGroupManagement/station_group_management.vue"),
      },
      {
        meta: {
          bread: { path: "/index/system/operation_log", title: "操作日志" },
        },
        name:'141',
        path: "/index/system/operation_log",
        component: () => import("../views/System/OperationLog/operation_log.vue"),
      },
      {
        meta: {
          bread: { path: "/index/friendly_chain", title: "友链" },
        },
        name:'72',
        path: "/index/friendly_chain",
        component: () => import("../views/Configure/FriendlyChain/index.vue"),
      },
    ],
  },
  // {
  //   path: '*', // 路由地址没有匹配到 会走这里
  //   component: Login  // 404 组件
  // }
];

// 导出
export default new VueRouter({
  routes,
});
